import React from 'react';
import axios from 'axios';
import { baseAPI } from '../../../../config';
import { toast } from 'react-toastify';
import userStore from '../../../../store/userStore';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import EmailModal from './components/EmailModal';
import AddAnnotationModal from './components/AnnotationModal';
import CallModal from '../../../../components/CallModal';
import { canCommunicate } from '@claimup/shared/helpers/permissions';
import { EXPEDIENT_TYPES } from '@claimup/shared/constants/expedient';
import { AR_SMS_MAX_LENGTH } from '@claimup/shared/constants/ar-arranque';

export default function ActionsOptions({ expedientId, debtorId, expedientType }) {
  const { user } = userStore();
  // Comunicación (email/SMS/llamada/WhatsApp) según rol×tipo: operator nunca;
  // gestor/company solo en AR. Las anotaciones no dependen de esto.
  const canComm = canCommunicate(user?.role, expedientType);

  const isAr = expedientType === EXPEDIENT_TYPES.ACCOUNT_RECEIVABLE;

  const handleSendSMS = async () => {
    // En AR el texto lo escribe quien lo manda (docs/contactar-deudor-ar-plan.md);
    // fuera de AR sale el de recobro de siempre.
    let message;
    if (isAr) {
      // eslint-disable-next-line no-alert
      message = window.prompt(`Texto del SMS (máximo ${AR_SMS_MAX_LENGTH} caracteres)`);
      if (!message || !message.trim()) return;
    }
    if (isAr || window.confirm('¿Seguro que quieres enviar un SMS?')) {
      try {
        await axios.post(
          `${baseAPI}/actions/sendsmstodebtor`,
          {
            expedientId,
            debtorId,
            ...(isAr ? { message: message.trim() } : {}),
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        toast.success('SMS enviado correctamente');
      } catch (error) {
        console.error('Error enviando el SMS:', error);
        toast.error(error.response?.data?.error || 'Error al enviar el SMS 😞');
      }
    }
  };

  return (
    <>
      <div className='flex gap-2'>
        {canComm && (
          <>
            <div className='flex-1'>
              <EmailModal expedientId={expedientId} />
            </div>

            <button
              className='flex-1 px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 text-sm font-medium transition-colors flex items-center justify-center gap-2'
              onClick={handleSendSMS}
            >
              <ChatBubbleLeftRightIcon className='w-4 h-4' />
              SMS
            </button>

            {/* En AR se llama desde la sesión de llamadas, con el número del gestor. */}
            {!isAr && (
              <div className='flex-1'>
                <CallModal expedientId={expedientId} debtorId={debtorId} />
              </div>
            )}
          </>
        )}

        <div className='flex-1'>
          <AddAnnotationModal idExpedient={expedientId} usuario={user} />
        </div>
      </div>

      {/* Modales */}
    </>
  );
}
